import { render } from "./EditHolidayModal.vue?vue&type=template&id=48eaf969&scoped=true"
import script from "./EditHolidayModal.vue?vue&type=script&lang=js"
export * from "./EditHolidayModal.vue?vue&type=script&lang=js"

import "./EditHolidayModal.vue?vue&type=style&index=0&id=48eaf969&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48eaf969"]])

export default __exports__